<div
	*ngIf="venueDetail$ | async as venueDetail"
	class="venue-container"
	[ngClass]="{ 'container--sidenav-opened': menuOpened.sidenavOpened  && !isMobile}"
>
	<div class="header">
		<button (click)="this.location.back()">
			<mat-icon svgIcon="porto-bank-icons:left-arrow"></mat-icon>
			Voltar
		</button>
		<h1>Detalhes do restaurante</h1>
	</div>

	<ui-porto-bank-swiper-container>
		<swiper-slide *ngFor="let url of venueDetail.bannersURL">
			<figure class="image-container">
				<img [src]="url | optimizeImage : 'webp': 1320 : 408" *ngIf="!isMobile" />
				<img [src]="url | optimizeImage" *ngIf="isMobile" />
			</figure>
		</swiper-slide>
	</ui-porto-bank-swiper-container>

	<div class="venue-details">
		<h2 class="venue-title">{{ venueDetail.name }}</h2>

		<div class="venue-address">
			<p>{{ venueDetail.address.value }}</p>
		</div>

		<a [href]="venueDetail.liveMenuURL" class="livemenu-button" target="_blank">
			<span>Ver menu</span>
		</a>

		<ul class="venue-actions">
			<!-- Benefícios -->
			<li style="margin-bottom: 20px">
				<a class="accordion-header" (click)="toggleAccordion('beneficios')">
					<p class="hour-title">Benefícios</p>
					<mat-icon
						svgIcon="picpay-icons:right_arrow"
						[class.expanded]="openSection === 'beneficios'"
					></mat-icon>
				</a>

				<div
					*ngIf="openSection === 'beneficios'"
					class="accordion-content"
					style="display: flex; flex-direction: column; gap: 16px"
				>
					<div *ngFor="let benefit of venueDetail.benefits" class="benefits">
						<div class="benefits__value">
							<mat-icon svgIcon="porto-bank-icons:check"></mat-icon>
							{{ benefit.type === 'discount' ? (benefit.value + ' de desconto') : benefit.name
							}}
						</div>

						<p>{{benefit.descriptionLong}}</p>
					</div>
				</div>
			</li>

			<!-- Sobre o restaurante -->
			<li style="margin-bottom: 20px">
				<a class="accordion-header" (click)="toggleAccordion('info')">
					<p class="hour-title">Sobre o restaurante</p>
					<mat-icon
						svgIcon="picpay-icons:right_arrow"
						[class.expanded]="openSection === 'info'"
					></mat-icon>
				</a>

				<div *ngIf="openSection === 'info'" class="accordion-content">
					<p>{{ venueDetail.descriptionLong }}</p>
				</div>
			</li>

			<!-- Horário de funcionamento -->
			<li style="margin-bottom: 20px">
				<a class="accordion-header" (click)="toggleAccordion('horarios')">
					<p class="hour-title">Horário de funcionamento</p>
					<mat-icon
						svgIcon="picpay-icons:right_arrow"
						[class.expanded]="openSection === 'horarios'"
					></mat-icon>
				</a>

				<div *ngIf="openSection === 'horarios'" class="accordion-content">
					<p
						*ngFor="let schedule of venueDetail.operationHours.value"
						style="display: flex; gap: 20px"
					>
						<span style="width: 80px"><b>{{ schedule.day }}: </b></span>
						<span>{{schedule.times}}</span>
					</p>
				</div>
			</li>

			<!-- Horário de Checkin -->
			<li *ngIf="venueDetail.checkin.enabled">
				<a class="accordion-header" (click)="toggleAccordion('checkin')">
					<p class="hour-title">Horário de check-in</p>
					<mat-icon
						svgIcon="picpay-icons:right_arrow"
						[class.expanded]="openSection === 'checkin'"
					></mat-icon>
				</a>

				<div *ngIf="openSection === 'checkin'" class="accordion-content">
					<p>
						<b> {{ getFirstDay(venueDetail) }} a {{ getLastDay(venueDetail) }}: </b>
						{{ formatHour(venueDetail.checkin.time?.startTime) }} às {{
						formatHour(venueDetail.checkin.time?.endTime) }}
					</p>
				</div>
			</li>
		</ul>
	</div>

	<div style="height: 120px; width: 100%"></div>

	<div class="container-footer-buttons" [class.no-client]="!(client$ | async)?.id">
		<div class="footer-buttons">
			<button
				mat-button
				class="footer-button"
				(click)="onReservationClick(venueDetail!)"
				[class.disabled]="!venueDetail.reservation?.enabled"
			>
				<span>Reserva</span>
			</button>
			<button
				mat-button
				class="footer-button"
				(click)="onCheckinClick(venueDetail!)"
				[class.disabled]="venueDetail.checkin.status === 'unavailable' || venueDetail.checkin.status === 'disabled'"
			>
				<span>Check-in</span>
			</button>
		</div>
	</div>
</div>
